<div class="profile-pic" (click)="openFileBrowser()">
  <img class="img" [src]="imgSrc()" alt="Patient profile picture"/>
  <div class="img-overlay">
    <mat-icon>photo_camera</mat-icon>
  </div>
</div>
<input #fileInput type="file" accept="image/*" class="file-hidden" (change)="onFileChanged($event)"/>
